module.exports = __webpack_public_path__ + "img/no_payment_credits.157a5048.svg";